import { Field, Link } from 'Components/Core';
import { ListFieldSection, PageSection } from 'Components/Layout';
import { RootState } from 'Data/Redux';
import { actions } from 'Data/ReduxViewModels/Admin';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ISectionParams } from '../types';
import { AgsExportConfigurationListRowAdmin } from './AgsExportConfigurationListRowAdmin';

const AgsExportConfigurationSectionAdmin: React.FC<ISectionParams> = ({
  agsVersion,
  agsExportConfigurationDeleteDialog,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const idForNewItem: string | null = useSelector((state: RootState) => state.admin.agsExportConfiguration.create.id);

  useEffect(() => {
    if (idForNewItem) {
      navigate(`/admin/ags-export-configuration/${idForNewItem}`);
    }
  }, [navigate, dispatch, idForNewItem]);

  const createNewAgsExportConfiguration = (agsVersion: string) => {
    dispatch(
      actions.createAgsExportConfiguration({
        newAgsExportConfiguration: { Name: '', AgsVersion: agsVersion, Content: '' },
      })
    );
  };

  return (
    <PageSection heading={'AGS ' + agsVersion.AgsVersion} key={agsVersion.AgsVersion}>
      {agsVersion.Configurations.map((configuration, id) => (
        <AgsExportConfigurationListRowAdmin
          configuration={configuration}
          agsExportConfigurationDeleteDialog={agsExportConfigurationDeleteDialog}
          key={agsVersion + '_' + id}
        />
      ))}
      <ListFieldSection single>
        <Field
          input={<Link />}
          to={'#'}
          content="Add Custom Configuration"
          onClick={() => {
            createNewAgsExportConfiguration(agsVersion.AgsVersion);
          }}
        />
      </ListFieldSection>
    </PageSection>
  );
};

export default AgsExportConfigurationSectionAdmin;
export { AgsExportConfigurationSectionAdmin };
